module.exports = __webpack_public_path__ + "static/media/maria-orez.70c03e01.jpg";